import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Divider from '@material-ui/core/Divider';
import Slide from '@material-ui/core/Slide';
import { TransitionProps } from '@material-ui/core/transitions';
import PlayCircleOutline from '@material-ui/icons/PlayCircleOutline';

import Communicator from '../../../helpers/communication-adapter';
import {
    CommunicationMessageTypes, LessonControlMessage, LessonState
} from '../../../helpers/constants';
import useCommunicator from '../../../hooks/useCommunicator';
import {
    startAttemptAC, startExecutorAC, updateDialogMonitor_AC
} from '../../../store/actions/executor.actions';
import { IControlMessage, LessonControlTypes } from '../../../types/communicator-types';

const CustomDialogTitle = styled(DialogTitle)`
  display: flex;
  justify-content: center;
`;

const CenteredIconContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const PlayCircleOutlineIcon = styled(PlayCircleOutline)`
  cursor: pointer;
  font-size: 100px !important;
`;

interface IStartLessonProps {
  preferredDialogMonitor: string;
}
const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children?: React.ReactElement<any, any> },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const StartLesson: React.FC<IStartLessonProps> = (props) => {
  const { preferredDialogMonitor } = props;
  const executorStatus = useSelector((state: any) => state.executor.status);
  const resources = useSelector((state: any) => state.resources);
  const dispatch = useDispatch();
  const communicator = useCommunicator<IControlMessage>(
    CommunicationMessageTypes.ControlMessage
  );

  const startExecutor = () => {
    if (!Communicator.isReady) {
      alert('Networking capabilities are not ready yet. Try later');
      return;
    }
    communicator?.postMessage({
      lessonState: LessonState.STARTED,
      type: LessonControlTypes.LessonStateControl,
    });
    dispatch(
      startExecutorAC(resources.lessonDefinition, {
        role: resources.role,
        lang: 'en',
        mode: resources.mode || 'demo',
      })
    );
    dispatch(updateDialogMonitor_AC({ monitor: preferredDialogMonitor }));
    communicator?.postMessage({
      controlMessage: LessonControlMessage.UPDATE_DIALOG_MONITOR,
      monitor: preferredDialogMonitor,
      type: LessonControlTypes.LessonControl,
    });
    dispatch(startAttemptAC());
  };
  return (
    <Dialog
      open={executorStatus === LessonState.INITIAL}
      TransitionComponent={Transition}
      keepMounted
      disableBackdropClick
      aria-labelledby="play-lesson-dialog"
    >
      <CustomDialogTitle id="play-lesson-dialog-title">
        Ready to start the lesson?
      </CustomDialogTitle>
      <Divider />
      <DialogContent>
        <DialogContentText id="play-lesson-dialog-description">
          <CenteredIconContent>
            <PlayCircleOutlineIcon
              fontSize="large"
              onClick={() => startExecutor()}
            />
          </CenteredIconContent>
          Note: Please wait for all the windows to open, arrange them in
          respective monitors and when you are ready click on the play button to
          start playing the lesson.
        </DialogContentText>
      </DialogContent>
    </Dialog>
  );
};

export default StartLesson;
